import { Pipe, PipeTransform } from '@angular/core';
import { AcpService } from '@services/common/acp.service';

@Pipe({
    standalone: false,
    name: 'acpText',
    pure: true
})
export class AcpResourcePipe implements PipeTransform {
    constructor(
        private AcpSer: AcpService,
    ) { }

    transform(value: string | any) {
        return this.AcpSer.acpFormat(value);
    }
}